import NavbarNew from "../components/layout/NavbarNew";
import FooterNew from "../components/layout/FooterNew";
import HeroV2 from "../components/sections/HeroV2";
import BentoSection from "../components/sections/BentoSection";
import CryptoSection from "../components/sections/CryptoSection";
import ShowcaseSection from "../components/sections/ShowcaseSection";
import { FeaturesSection, StatsSection, CTASection } from "../components/sections/SectionsNew";

export default function PreviewPage2() {
  return (
    <div style={{ background: "#080C14", minHeight: "100vh", overflowX: "hidden" }}>
      <NavbarNew />
      <main>
        <HeroV2 />
        <BentoSection />
        <CryptoSection />
        <ShowcaseSection />
        <FeaturesSection />
        <StatsSection />
        <CTASection />
      </main>
      <FooterNew />
    </div>
  );
}
